export default "__VITE_ASSET__exBRGVU0__"